import List from '../../../app/shared/components/List/List';
import HeaderLevel3 from '../../../app/shared/components/Typography/HeaderLevel3';
import { OrderDetailsProductTranslation } from '../../localization/SiteTranslation';
import { OrderItem } from '../OrderItem';
import { OrderItemGroup } from '../OrderItemGroup/OrderItemGroup';
import { OrderItemGroupState } from '../OrderItemGroup/OrderItemGroupState';
import { OrderItemState } from '../OrderItemState';
import css from './OrderDetailsProducts.css';

interface OrderDetailsProductsProps {
  orderItems: Array<OrderItemState | OrderItemGroupState>;
  translation: OrderDetailsProductTranslation;
}

export const OrderDetailsProducts = ({ orderItems, translation }: OrderDetailsProductsProps) => {
  return (
    <div>
      <HeaderLevel3 className={css.OrderDetailsProductsTitle}>{translation.productsHeader}</HeaderLevel3>
      <div>
        <List
          items={orderItems}
          className={css.orderDetailsProductList}
          itemClassName={css.orderDetailsProductItem}
          itemRenderer={(itemState) => <LineItem state={itemState} translation={translation} />}
        />
      </div>
    </div>
  );
};

interface LineItemProps {
  state: OrderItemState | OrderItemGroupState;
  translation: OrderDetailsProductTranslation;
}

const LineItem = ({ state, translation }: LineItemProps) => {
  if (state instanceof OrderItemState) {
    return <OrderItem state={state} translation={translation} />;
  }

  if (state instanceof OrderItemGroupState) {
    return <OrderItemGroup state={state} translation={translation} />;
  }

  return null;
};
